import React, {useState, useEffect} from 'react'
import {ContainerMain} from '../common/commonStyles'
import { MainContainer, TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { BorderBottom, TabBottomLine, TabWrapper } from '../RecogntionAdmin/styles';
import Department from './department';
import Location from './location'
import { GetDepartmentsWithManagers } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { fetchApi } from '../../utils/methods';
import { connect } from "react-redux";

const Manager = ({companyId, history, brandingColor}) => {

  useEffect(()=>{
    getManagerDataByDepartment(companyId)
  },[companyId])

  const [tabValue, manageTabs ]=useState('department')
  const [getDepartment, setDepartment ]=useState([])
  let getColor = brandingColor ? brandingColor : "rgba(243, 122, 101, 1)"
  const setTabs = (value) => {
    manageTabs(value)
  }

  const getManagerDataByDepartment = async(companyId)=>{
    try {
      const res = await fetchApi(`${GetDepartmentsWithManagers + "/" + companyId}`, "GET");
      if(res.status === "success"){
        setDepartment(res.data)
      }else{
        // toast.error(error.message);
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  return(
    <ContainerMain style={{paddingTop:"0"}}>
      <div className="content-wrap">
        <MainContainer margin>
          <TopContainerWrapper style={{ flexWrap: "wrap" }}>
            <TabWrapper>
              <TabBottomLine id="hdm-wba-overviewtab" active={tabValue == "department"} background={getColor ? getColor : "#0b4170"} onClick={() => setTabs("department")}>
                Department
                <BorderBottom active={tabValue == "department"} background={getColor ? getColor : "#0b4170"} />
              </TabBottomLine>
              <TabBottomLine id='hdm-wba-assessmenttab' active={tabValue == "location"} background={getColor ? getColor : "#0b4170"} onClick={tabValue == "location" ? null : () => setTabs("location")}>
                Location
                <BorderBottom active={tabValue == "location"} background={getColor ? getColor : "#0b4170"} />
              </TabBottomLine>
            </TabWrapper>
          </TopContainerWrapper>
        </MainContainer>
        {tabValue==="department"?<Department departmentData={getDepartment} history={history} companyId={companyId} getManagerDataByDepartment={getManagerDataByDepartment}/>:<Location  history={history} companyId={companyId}/>}
      </div>
    </ContainerMain>
  )
}

Manager.propTypes = {
  companyId: PropTypes.number,
  history: PropTypes.object,
  brandingColor:PropTypes.string
};

const mapStateToProps = (state) => ({
  brandingColor:state.wellnessDashboard.brandingColor
});

export default connect(mapStateToProps, null)(Manager);